module.exports = __webpack_public_path__ + "img/playtop_sp@2x.523097d0.png";